import React from "react";
import { connect } from "react-redux";

import LookCanvasContext from "../../../lookCanvasContext";
import LookWizardContentTitle from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentTitle";
import LookWizardContentDescription from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentDescription";
import LookWizardContentCanvas from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentCanvas";
import GroheWizardContentFeature from "./groheWizardContentFeature";
import {
  getCurrentGroups,
  getFeatureGroupFromWizardGroup
} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {
  setWizardActiveStep,
  setWizardSelectedValues,
  setWizardShowFeatureSection
} from "../../../../../actions/wizardFunctions";
import LookWizardContentFinalPrice from "../../../lookNavigation/lookMain/lookWizard/lookWizardContentFinalPrice";
import GroheWizardSelectedSteps from "./groheWizardSelectedSteps";
import GroheWizardContentSingleFeature from "./groheWizardContentSingleFeature";
import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";

const GroheWizardContent = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, isMobile} = props;


  let showFinalPrice = false;

  if (wizardActiveStep > -1) {
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (currentGroups.length === 1) {
      const featureGroup = getFeatureGroupFromWizardGroup(currentGroups[0]);
      if (wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature) {
        if (currentGroups[0].title && wizardSelectedValues[wizardActiveStep].singleFeature) {
          return <GroheWizardContentSingleFeature feature={wizardSelectedValues[wizardActiveStep].selectedFeature}
                                                  wizardGroup={currentGroups[0]}/>
        }
        return <GroheWizardContentFeature feature={wizardSelectedValues[wizardActiveStep].selectedFeature}
                                          wizardGroup={currentGroups[0]}/>
      } else if (featureGroup && featureGroup.activeFeature && !currentGroups[0].title) {
        return <GroheWizardContentFeature feature={featureGroup.activeFeature}
                                          wizardGroup={currentGroups[0]}/>
      }
    } else if (isMobile && !currentGroups.length && wizardActiveStep > -1) {
      showFinalPrice = true;
    }
  }

  return (
    <div className={isMobile ? "" : "grohe-wizard__main"}>
      <h2 className="grohe-section__title grohe-section__title--full grohe-section__title--wizard">
        <LookWizardContentTitle/>
      </h2>
      <p className="grohe-section__description grohe-section__description--full grohe-section__description--wizard">
        <LookWizardContentDescription/>
      </p>
      {showFinalPrice ? (
        <div className="grohe-wizard__final">
          <LookWizardContentFinalPrice/>
          <GroheWizardSelectedSteps isMobile={false}/>
        </div>
      ) : (
        <LookCanvasContext.Consumer>
          {(imageCanvas) => (
            <LookWizardContentCanvas imageCanvas={imageCanvas}/>
          )}
        </LookCanvasContext.Consumer>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardShowFeatureSection, wizardSqftCartItems}
    = store.wizardState;
  const {isMobile, visualizersLoaded} = store.serverState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    wizardShowFeatureSection,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
    wizardSqftCartItems,
  };
};

const mapDispatchToProps = {
  setWizardShowFeatureSection,
  setWizardSelectedValues,
  setGroheActiveFeatureQuantity,
  setWizardActiveStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheWizardContent)
